export default __webpack_public_path__ + "static/gallery1-62d3165b109874b439c9989d93aeb44b.png";